<button class="item full-width" (click)="onClick($event)" (mouseover)="open()">
  @if (opensChildMenu) {
    <div>
      <svg-icon icon="icon-caret-right" class="tiny"></svg-icon>
    </div>
  }
  <ng-content></ng-content>
</button>
